import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
import smoothscroll from 'smoothscroll-polyfill';

class Nav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        slideDisplay: PropTypes.number,
    };

    navBox = React.createRef();

    state = {
        data: [],
        isFixed: false,
        current: 0,
    };

    componentDidMount() {
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);

        try {
            smoothscroll.polyfill();
        } catch (e) {
            console.error(e);
        }

        const { content, slideDisplay } = this.props;

        const data = content
            .filter((item) => {
                let flag = false;

                if (item.title === '热门评论' && (!item.data || item.data[0]?.allowComment !== 1)) {
                    return false;
                }

                if (item.type === 'timeline') {
                    flag = true;
                }
                if (item.type === 'slide' && slideDisplay === 1 && item.data && item.data.length > 0) {
                    flag = true;

                    item.title = '焦点图';
                } else if (
                    item.type === 'flow' &&
                    item.display === 1 &&
                    item.data.articleList &&
                    item.data.articleList.length > 0
                ) {
                    flag = true;
                } else if (
                    item.type !== 'slide' &&
                    item.type !== 'flow' &&
                    item.display === 1 &&
                    item.data &&
                    item.data.length > 0
                ) {
                    flag = true;
                }

                return flag;
            })
            .map((item) => item.title);

        this.setState({
            data,
        });
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    // 兼容 ie7 的 offsetTop 获取方法
    getOffsetTop = (dom) => {
        let offsetTop = dom.offsetTop;

        if (dom.offsetParent) {
            offsetTop += this.getOffsetTop(dom.offsetParent);
        }

        return offsetTop;
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        const { isFixed } = this.state;

        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        let current = 0;
        const domArr = document.querySelectorAll('[data-title]');

        const len = domArr[domArr.length - 1]['data-title'] === '合作伙伴' ? domArr.length - 1 : domArr.length;

        Array.from(domArr)
            .slice(0, len)
            .every((item, index) => {
                const offsetTop = this.getOffsetTop(item);

                if (offsetTop > currentTop || offsetTop === currentTop) {
                    current = index;

                    return false;
                } else if (index === len - 1) {
                    current = index;

                    return false;
                }

                return true;
            });

        const navItemTop = this.getOffsetTop(document.querySelectorAll('[data-index]')[current]);

        if (isFixed) {
            if (navItemTop > 500) {
                this.navBox.current.scrollTo({ left: 0, top: navItemTop - 200, behavior: 'smooth' });
            } else {
                this.navBox.current.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }
        }

        this.tabsTop = this.getOffsetTop(domArr[0]);

        if (currentTop > this.tabsTop) {
            this.setState({ isFixed: true, current });
        } else {
            this.setState({ isFixed: false, current });
        }
    };

    scrollToItem = (e) => {
        const domArr = document.querySelectorAll('[data-title]');
        const current = Number(e.currentTarget.attributes['data-index'].value);
        const top = this.getOffsetTop(domArr[current]);

        window.scrollTo({ left: 0, top, behavior: 'smooth' });

        this.setState({ current });
    };

    /**
     * 渲染组件
     */
    render() {
        const { data, isFixed, current } = this.state;

        return (
            <div className={styles.navBorder}>
                <div className={isFixed ? styles.fix_nav_box : styles.nav_box} ref={this.navBox}>
                    {data.map((item, index) => (
                        <div
                            key={index}
                            className={current === index ? styles.current_box : styles.item_box}
                            data-index={index}
                            onClick={this.scrollToItem}>
                            <span>{item}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Nav);
